import type { Starter } from '../Starter'

export const strategyStarters: Starter[] = [
  {
    id: 'swot-basic',
    name: 'SWOT Analysis',
    description: 'Four-quadrant strategy',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'swot-basic', diagramType: 'flowchart' },
    job: ['plan-strategy'],
    function: ['strategy'],
    popular: true,
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'bmc-basic',
    name: 'Business Model Canvas',
    description: 'Nine building blocks',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'bmc-basic', diagramType: 'flowchart' },
    job: ['plan-strategy'],
    function: ['strategy'],
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'okr-cascade',
    name: 'OKR Cascade',
    description: 'Objectives to key results',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'okr-cascade', diagramType: 'flowchart' },
    job: ['plan-strategy'],
    function: ['strategy'],
    trigger: 'planning-cycle',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'comparison-matrix',
    name: 'Comparison Matrix',
    description: 'Options × criteria',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'comparison-matrix', diagramType: 'flowchart' },
    job: ['plan-strategy'],
    function: ['strategy'],
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'pestle',
    name: 'PESTLE Analysis',
    description: 'Macro factors',
    thumbnailUrl: 'https://svg.template.creately.com/jn2uxnc52',
    artifact: { kind: 'legacy', templateId: 'jn2uxnc52', legacyType: 'diagram/def/block.js#Block' },
    job: ['plan-strategy'],
    function: ['strategy'],
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'porters-five-forces',
    name: 'Five Forces',
    description: 'Industry forces',
    thumbnailUrl: 'https://svg.template.creately.com/P5hnMMgl12w',
    artifact: { kind: 'legacy', templateId: 'P5hnMMgl12w', legacyType: 'diagram/def/block.js#Block' },
    job: ['plan-strategy'],
    function: ['strategy'],
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'product-roadmap',
    name: 'Product Roadmap',
    description: 'Now / next / later',
    thumbnailUrl: 'https://svg.template.creately.com/jno8mrrp2',
    artifact: { kind: 'legacy', templateId: 'jno8mrrp2', legacyType: 'diagram/def/block.js#Block' },
    job: ['plan-strategy'],
    function: ['strategy', 'projects'],
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
]
